// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__6QMKV","active":"styles_active__+jHKE"};